"use client"
import Posts from "@/components/Posts/Posts"
import Container from "@/components/Container/Container"
import ReactPaginate from "react-paginate"
import { updateQueryParams } from "@/utils/readingroom"

import { useState, useEffect } from "react"
import { useRouter } from "next/navigation"

export const revalidate = 60

export default function PostsPage({ posts, itemsPerPage, page = 1 }) {
  const [items, setPosts] = useState(posts.results)
  //   const [isLoading, setIsLoading] = useState(true)
  const [itemsCount, setItemsCount] = useState(posts.count)
  const [currentPage, setCurrentPage] = useState(page)
  //   const [apiError, setApiError] = useState(false)

  const router = useRouter()

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1)
    // router.push("/posts")
  }

  useEffect(() => {
    if (currentPage == 1) {
      updateQueryParams({ page: false }, "/posts", router)
    } else {
      updateQueryParams({ page: currentPage }, "/posts", router)
    }
  }, [currentPage])

  const pageCount = Math.ceil(itemsCount / itemsPerPage)

  return (
    <>
      {items.length ? (
        <div className="posts-page">
          <Container className="posts-page__container">
            <Posts items={items} />

            {itemsCount > itemsPerPage && (
              <ReactPaginate
                forcePage={currentPage - 1}
                className="pagination"
                breakLabel=""
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                nextLabel=""
                previousLabel=""
                renderOnZeroPageCount={null}
                previousLinkClassName="pagination__arrow pagination__arrow_prev"
                nextLinkClassName="pagination__arrow pagination__arrow_next"
                disabledLinkClassName="disabled"
                pageClassName="pagination__page"
                activeClassName="active"
              />
            )}
          </Container>
        </div>
      ) : null}
      {/* {isLoading ? (
        <Container>Loading...</Container>
      ) : posts.length ? (
        <div className="posts-page">
          <Container className="posts-page__container">
            <Posts items={posts} />

            {itemsCount > itemsPerPage && (
              <ReactPaginate
                className="pagination"
                breakLabel=""
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                nextLabel=""
                previousLabel=""
                renderOnZeroPageCount={null}
                previousLinkClassName="pagination__arrow pagination__arrow_prev"
                nextLinkClassName="pagination__arrow pagination__arrow_next"
                disabledLinkClassName="disabled"
                pageClassName="pagination__page"
                activeClassName="active"
              />
            )}
          </Container>
        </div>
      ) : apiError ? (
        <div className="api-error">
          <Container>
            An error occurred while retrieving posts from the API, or there are
            no posts created yet.
          </Container>
        </div>
      ) : null} */}
    </>
  )
}
